import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Button, message, Carousel, Modal, Select, Form,Switch } from 'antd'
import {
  BellFilled,
  ExclamationCircleOutlined,
  LeftOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  EditOutlined,
} from '@ant-design/icons'
import '../../css/patient.scss'
import PatientPie from './patient.pie'
import { constants } from '../../constants'
import _ from 'lodash'
import moment from 'moment'
import serviceInterface from '../../services/service.interface'
import PatientNotifyList from './patient.notify.list'
import {
  getPatientNots,
  setPatNotifications,
} from '../../store/action/patient.action'
import PatientMeasurement from './patient.measurement'
import Forms from './forms/index'
import DeviceStatus from './device.status'
import { updateDeviceSchedule } from '../../store/action/device.action'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import {
  getCompanyHealthcoach,
  putPatientOnHold,
} from '../../store/action/user.action'
import {
  loginAsCustomer,
  loginAsCompany,
} from '../../store/action/profile.action'
import HealthCoachEdit from './healthcoach.edit'

import {} from '@ant-design/icons'
import PatientForm from './patient.form'
import PatientActiveModal from './forms/patient.active.modal'
import { getPatient, resetLoginFailedCount } from '../../store/action/patient.action'
import PatientDiagnoses from './patient.diagnoses'
// var {Forms, Calendar, Buttons, Events, Info} = Patient

const VIEW_TYPE = {
  NOTIFICATION: 1,
  INFORMATION: 2,
}

const SORT_TYPE = {
  ASC: 1,
  DSC: 2,
  NONE: 3,
}

const PatientInfo = (props) => {
  // var surgeonName = patient.surgeon.name;
  const [loading, setLoading] = useState(false)
  const [view, setView] = useState(VIEW_TYPE.INFORMATION)
  const [notifications, setNots] = useState([])
  const [sort, setSort] = useState(SORT_TYPE.DSC)
  const [scoreModal, setScoreModal] = useState(false)
  const [healthCoachModal, setHealthCoachModal] = useState(false)
  const [deviceModal, setDeviceModal] = useState(false)
  var { exerciseSchedule, _id, surgery, firstname, lastname, dailyshift } =
    props.patient
  var [hc, setHc] = useState([])
  const [hcdetail, setHcDetail] = useState(props.patient?.healthcoach)
  const [companyUser, setCompanyuser] = useState(
    props.role == constants.ROLE.COMPANY_HEALTHCOACH ||
      props.role == constants.ROLE.COMPANY_ADMIN
  )
  const [holdbtn, setHoldbtn] = useState(null)
  const history = useHistory()
  const [type, setType] = useState()
  const [rightForm, setRightForm] = useState(false)
  const [leftForm, setLeftForm] = useState(true)
  const [open, setOpen] = useState(false)
  const [formindex, setFormindex] = useState()
  const [isActive, setisActive] = useState(true);
  const [isActiveModal,setIsActiveModal]=useState(false);

  // Check if patient's surgery type is surgical
  const isSurgical = () => {
    if (!props.patient?.customer?.surgerytypes || !props.patient?.surgery?.type) {
      return true // Default to surgical if we can't determine
    }
    const surgeryType = props.patient.customer.surgerytypes.find(
      st => st.name.toLowerCase() === props.patient.surgery.type.toLowerCase()
    )
    return surgeryType ? surgeryType.issurgical : true
  }
  useEffect(() => {
    setHcDetail(props.patient?.healthcoach)
  }, [props.patient?.healthcoach])

  useEffect(() => {
    getHealthcoachlist()
    return () => {
      props.setNotifications([])
    }
  }, [])
  useEffect(() => {
    props.getNotifications(props.patient?._id)
  }, [props.patient?._id])

  useEffect(() => {
    setHoldbtn(props.patient?.technicalholdhistory?.status != 'hold')
  }, [props.patient?.technicalholdhistory?.status])

  // Update HcDetail
  const updateHcDetail = (hcdetail) => {
    setHcDetail(hcdetail)
  }

  var getHealthcoachlist = async () => {
    console.log('HCS', props.patient._id)
    var data = await props.getCompanyHealthcoach(
      props.company ? props.company?._id : props.companyid
    )
    console.log('HCD', data)
    setHc(data)
  }

  // useEffect(() => {
  //     if (view == VIEW_TYPE.NOTIFICATION) {
  // setLoading(true)
  // props.getNotifications(props.patient._id)
  // .then((res) => setLoading(false));
  //     }
  // }, [view]);

  useEffect(() => {
    if (sort == SORT_TYPE.ASC)
      setNots(_.orderBy(props.notifications, ['date'], ['asc']))
    else if (sort == SORT_TYPE.DSC)
      setNots(_.orderBy(props.notifications, ['date'], ['desc']))
    else setNots(props.notifications)
  }, [props.notifications])

  const handleSortClick = () => {
    // if (sort == SORT_TYPE.NONE) {
    // setSort(SORT_TYPE.ASC);
    // setNots(_.orderBy(props.notifications, ['date'], ['asc']));
    // } else
    if (sort == SORT_TYPE.ASC) {
      setSort(SORT_TYPE.DSC)
      setNots(_.orderBy(props.notifications, ['date'], ['desc']))
    } else if (sort == SORT_TYPE.DSC) {
      setSort(SORT_TYPE.ASC)
      setNots(_.orderBy(props.notifications, ['date'], ['asc']))
    }
  }

  const reOrderDeviceSchedule = async (assignedDevices) => {
    console.log('props.newPatient', props.newPatient)
    var newPatient = {
      firstname,
      lastname,
      surgery,
      _id,
      dailyshift: {
        start: {
          hour: dailyshift?.start?.hour,
          minute: dailyshift?.start?.minute,
        },
        end: {
          hour: dailyshift?.end?.hour,
          minute: dailyshift?.end?.minute,
        },
      },
    }

    var response = await props.updateDeviceSchedule(
      newPatient,
      assignedDevices,
      true
    )
    return response
  }

  const handleNotificationChange = () => {
    setLoading(true)
    props.getNotifications(props.patient._id).then((res) => {
      setLoading(false)
      setView(VIEW_TYPE.NOTIFICATION)
    })
  }

  useEffect(() => console.log('BTN', holdbtn), [holdbtn])

  const showKneeScore = () => {
    setScoreModal(true)
  }

  const editHealthCoach = () => {
    setHealthCoachModal((prev) => !prev)
  }

  const showDeviceModal = () => {
    setDeviceModal((prev) => !prev)
  }

  const renderHealthcoach = () => {
    return hc.users?.map((i) => (
      <Select.Option value={i._id}>{i.firstname}</Select.Option>
    ))
  }

  const putPatientOnHold = async (isNew = false) => {
    var res = await props.putPatientOnHold(isNew, props.patient._id)
    console.log('DOP', res.status, constants.MESSAGE.SUCCESS)
    if (res.status == constants.MESSAGE.SUCCESS) {
      setHoldbtn(!holdbtn)
    }
  }

  const onHoldConfirm = () => {
    Modal.confirm({
      title: holdbtn
        ? 'Do you want to put patient on technical hold'
        : 'Do you want release patient technical hold',
      icon: <ExclamationCircleOutlined />,
      okText: 'Ok',
      onOk: putPatientOnHold,
    })
  }

  const onResetFailedLoginsConfirm = () => {
    Modal.confirm({
      title: 'Reset this patient\'s failed login attempts?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Reset',
      onOk: async () => {
        const res = await props.resetLoginFailedCount(props.patient._id)
        if (res) props.fetchPatient(props.patient._id)
      },
    })
  }

  const handleEdit = () => {
    history.push({
      pathname: '/patient/edit/info',
      state: { home: true, patient: props.patient },
    })
  }

  const getLastForm = (type) => {
    var res = serviceInterface
      .PatientService()
      .getLastForm({
        formtype: type,
        schedules: [...props.patient.feedbackSchedule.feedbackdateschedule],
      })
    if (!res) return
    setType(type)
    setOpen(true)
  }

  return (
    <Col className='patientInfoContainer'>
      <Row className='infoHeader'>
        {view == VIEW_TYPE.INFORMATION && loading == false ? (
          <span>Provider : {props.patient?.surgeon?.name}</span>
        ) : (
          <>
            <span>
              {' '}
              <LeftOutlined
                className='bck-icon'
                onClick={() => setView(VIEW_TYPE.INFORMATION)}
              />{' '}
              &nbsp; Notifications
            </span>
            {/* <Col className="sort-btn" onClick={handleSortClick}>
                        <Row style={{color: sort == SORT_TYPE.ASC ? 'rgb(10, 44, 76)' : 'white'}} className="sort-up" align="middle" justify="center"><CaretUpOutlined /></Row>
                        <Row style={{color: sort == SORT_TYPE.DSC ? 'rgb(10, 44, 76)' : 'white'}} className="sort-down" align="middle" justify="center"><CaretDownOutlined /></Row>
                    </Col> */}
            <Col className='sort-btn-text' onClick={handleSortClick}>
              <i>Time</i> {sort == SORT_TYPE.ASC ? <b>↑</b> : <b>↓</b>}
            </Col>
          </>
        )}
      </Row>
      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        className='infoBody'
        align='middle'
      >
        <Col>
          <Row className='infoName' align='middle'>
            <Col flex={9}>
              {' '}
              {props.patient.gender == constants.GENDER.M ? 'Mr. ' : 'Ms. '}
              {_.upperFirst(props.patient.firstname) +
                ' ' +
                _.upperFirst(props.patient.lastname)}
            </Col>
            <Col flex={4}>
              <EditOutlined
                onClick={handleEdit}
                style={{
                  position: 'sticky',
                  cursor: 'pointer',
                  marginLeft: '100%',
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col >Status</Col>
              <Col  >
                {<PatientActiveModal _id={props.patient._id} activeState={props.patient?.active}/>}
              </Col>
          </Row>  

          <Row>Phone: XXXXX-X{props.patient.lastdigitsofphone}</Row>
          <Row>
            <Col>Surgery type: {props.patient?.surgery?.type}</Col>
          </Row>

        </Col>
      </Row>
      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        justify='end'
        className='infoBody'
      >
        <Col className='infoTitle'>AGE GROUP</Col>
        <Col flex='80px' align='right'>
          {props.patient?.age}
        </Col>
      </Row>

      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row justify='end'>
            <Col className='infoTitle' span={12}>
              {isSurgical() ? 'SURGERY DATE' : 'START DATE'}
            </Col>
            <Col span={12} align='right'>
              {moment(props.patient?.surgery?.date).format('MM/DD/YYYY')}
            </Col>
          </Row>
          {isSurgical() && (
            <Row justify='end'>
              <Col span={24} align='right'>
                {moment().startOf('day').diff(moment(props.patient?.surgery?.date).startOf('day'), 'days') >= 0
                  ? constants.SURGERYTIME.Post
                  : constants.SURGERYTIME.Pre}

                {' ' +
                  (
                    Math.abs(moment().startOf('day').diff(moment(props.patient?.surgery?.date).startOf('day'), 'days'))

                    ) +
                  ' days'}
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      {/* DIAGNOSES SECTION */}
      <PatientDiagnoses
        patientId={props.patient?._id}
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
      />

      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        className='infoBody'
        align='middle'
      >
        <Col style={{ width: '100%' }}>
          <Row justify='end'>
            <Col className='infoTitle'>HEALTH COACH</Col>
            <Col className='linkTitle' align='right'>
              {props.role == constants.ROLE.COMPANY_ADMIN && (
                <a onClick={editHealthCoach} disable={!props.patient?.active} className={!props.patient?.active?'disable-link':''}>
                  <u>
                    {props.patient?.healthcoach?.firstname ||
                    hcdetail?.firstname
                      ? 'EDIT'
                      : 'ADD'}
                  </u>
                </a>
              )}
            </Col>
          </Row>

          <Row>
            <Col>
              Name :{' '}
              {(hcdetail?.firstname || 'NA') +
                ' ' +
                (hcdetail?.lastname || ' ')}
            </Col>
          </Row>
          <Row>
            <Col>Email : {hcdetail?.email || 'NA'}</Col>
          </Row>
        </Col>
      </Row>

      <Row
        hidden={
          (view == VIEW_TYPE.NOTIFICATION && loading == false) || !companyUser
        }
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='infoTitle'>RAISED ISSUE</Col>
            <Col className='linkTitle'>
              <Link className={!props.patient?.active?'disable-link':''}
                onClick={() => props.loginAsCompany(props.company)}
                to={{
                  pathname: '/cases-add',
                  state: {
                    patientid: props.patient?._id,
                    type: constants.ACTION_CASE_TITLE.PATIENT_TECHNICAL,
                    userid: props.user._id,
                    HCid: hcdetail?._id || '',
                    lastFourDigits: props.patient.lastdigitsofphone?props.patient.lastdigitsofphone.toString():'',
                    back: '/patient/' + props.patient._id,
                    customer: props.customer,
                    firstname:props.patient?.firstname,
                    lastname:props.patient?.lastname,
                  },
                }}
              >
                <u>CREATE</u>
              </Link>
            </Col>
          </Row>
          <Row justify='end'>
            <Col style={{ marginRight: 'auto' }}>Open Cases:</Col>
            <Col className='linkTitle'>
              {props.patient?.cases?.length ? (
                <Button style={{ border: 'hidden' }}>
                  {' '}
                  <Link  className={!props.patient?.active?'disable-link':''}
                    onClick={() => props.loginAsCompany(props.company)}
                    to={{
                      pathname: '/cases',
                      state: { filters: { caseNumbers: props.patient?.cases } },
                    }}
                  >
                    {props.patient?.cases.length}
                  </Link>
                </Button>
              ) : (
                'NA'
              )}
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        hidden={
          (view == VIEW_TYPE.NOTIFICATION && loading == false) || companyUser
        }
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='infoTitle' span={12}>
              LAST SCORE
            </Col>
            {/*  <Col className="linkTitle" span={12} align="right" >
                        <a onClick={showKneeScore}><u>SCORE CHART</u></a>
                    </Col> */}
          </Row>
          <Row justify='end'>
            <Col style={{ marginRight: 'auto' }} span={14}>
              Pain level:
            </Col>
            <Col align='right' span={10}>
              <a onClick={() => getLastForm(constants.SCORE.PAIN_LEVEL)}>
                <u>
                  {' '}
                  {props.patient?.feedbackSchedule?.lastscores?.painlevel
                    ? props.patient?.feedbackSchedule?.lastscores?.painlevel
                    : 'NA'}
                </u>
              </a>
            </Col>
          </Row>

          {props.patient?.surgery?.type == 'knee' ? (
            <Row justify='end'>
              <Col style={{ marginRight: 'auto' }} span={14}>
                Knee score:
              </Col>
              <Col flex='150px' align='right' span={10}>
                <a onClick={() => getLastForm(constants.SCORE.KNEE_SCORE)}>
                  <u>
                    {' '}
                    {props.patient?.feedbackSchedule?.lastscores?.kneescore !==
                      undefined &&
                    props.patient?.feedbackSchedule?.lastscores?.kneescore !==
                      null
                      ? props.patient?.feedbackSchedule?.lastscores?.kneescore
                      : 'NA'}
                  </u>
                </a>
              </Col>
            </Row>
          ) : (
            <Row justify='end'>
              <Col style={{ marginRight: 'auto' }} span={14}>
                Hip score:
              </Col>
              <Col flex='150px' align='right' span={10}>
                <a onClick={() => getLastForm(constants.SCORE.KNEE_SCORE)}>
                  <u>
                    {' '}
                    {props.patient?.feedbackSchedule?.lastscores?.hiplevel !==
                      undefined &&
                    props.patient?.feedbackSchedule?.lastscores?.hiplevel !==
                      null
                      ? props.patient?.feedbackSchedule?.lastscores?.hiplevel
                      : 'NA'}
                  </u>
                </a>
              </Col>
            </Row>
          )}
          {props.patient?.surgery?.type == 'knee' ? (
            <>
              <Row justify='end'>
                <Col style={{ marginRight: 'auto' }} span={14}>
                  Flexion:
                </Col>
                <Col flex='150px' align='right' span={10}>
                  <a onClick={() => getLastForm(constants.SCORE.FLEXION)}>
                    <u>
                      {' '}
                      {props.patient?.feedbackSchedule?.lastscores?.flexion
                        ? props.patient?.feedbackSchedule?.lastscores?.flexion
                        : 'NA'}
                    </u>
                  </a>
                </Col>
              </Row>
              <Row justify='end'>
                <Col style={{ marginRight: 'auto' }} span={14}>
                  Extension:
                </Col>
                <Col flex='150px' align='right' span={10}>
                  <a onClick={() => getLastForm(constants.SCORE.FLEXION)}>
                    <u>
                      {' '}
                      {props.patient?.feedbackSchedule?.lastscores?.extension
                        ? props.patient?.feedbackSchedule?.lastscores?.extension
                        : 'NA'}
                    </u>
                  </a>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Row
        hidden={(view == VIEW_TYPE.NOTIFICATION && loading == false) || true}
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='infoTitle'>EXERCISE PROGRESS</Col>
          </Row>
          <Col className='infoTitle' style={{ padding: '20px' }}>
            {props.patient?.exerciseSchedule?.summary ? (
              <PatientPie
                index={props.patient?._id}
                data={props.patient?.exerciseSchedule?.summary}
                align='start'
              />
            ) : (
              'NA'
            )}
          </Col>
        </Col>
      </Row>
      <Row
        hidden={(view == VIEW_TYPE.NOTIFICATION && loading == false) || true}
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='infoTitle'>MEASUREMENT PROGRESS</Col>
          </Row>
          <Col className='infoTitle' style={{ padding: '20px' }}>
            <PatientMeasurement
              index={props.patient?._id}
              data={props.patient?.deviceSchedule}
              align='start'
              width='250px'
              companyUser={companyUser}
            />
          </Col>
        </Col>
      </Row>

      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='infoTitle'>ASSIGNED DEVICES</Col>
            <Col className='linkTitle'>
              <a onClick={showDeviceModal} className={!props.patient?.active?'disable-link':''}>
                <u>STATUS</u>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        hidden={
          (view == VIEW_TYPE.NOTIFICATION && loading == false) ||
          props.notifications?.length == 0
        }
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row>
            <Col className='linkTitle'>
              <a onClick={handleNotificationChange}>
                <u>NOTIFICATIONS SENT</u>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        hidden={view == VIEW_TYPE.NOTIFICATION && loading == false}
        className='infoBody'
      >
        <Col style={{ width: '100%' }}>
          <Row align='middle'>
            <Col>
              Failed logins: {props.patient?.login_failed_count || 0}
              <Button
                className='notification-btn'
                size='small'
                disabled={!props.patient?.login_failed_count}
                onClick={onResetFailedLoginsConfirm}
                style={{ marginLeft: '5px' }}
              >
                Reset
              </Button>
            </Col>
          </Row>
          {companyUser && (
            <Row>
              <Col>
                Technical Hold:
                <Button
                  className='notification-btn'
                  onClick={onHoldConfirm}
                  style={{
                    boxShadow:
                      '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
                    marginLeft: '5px',
                  }}
                >
                  {holdbtn ? 'Hold' : 'Release'}
                </Button>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      {/* DEVICE STATUS  */}
      <Row hidden={loading == false && view == VIEW_TYPE.INFORMATION}>
        <PatientNotifyList notifications={notifications} />
      </Row>
      <Modal
        visible={scoreModal}
        footer={false}
        onCancel={() => setScoreModal(false)}
      >
        {
          <Row>
            <Forms modal={false} />
          </Row>
        }
      </Modal>
      <Modal
        visible={healthCoachModal}
        footer={false}
        onCancel={() => setHealthCoachModal(false)}
      >
        {
          <Row>
            <HealthCoachEdit
              healthcoach={hc}
              healthcoachdetail={hcdetail}
              patientId={props.patient?._id}
              editHealthCoach={editHealthCoach}
              updateHcDetail={updateHcDetail}
              patientName={
                _.upperFirst(props.patient.firstname) +
                ' ' +
                _.upperFirst(props.patient.lastname)
              }
            />
          </Row>
        }
      </Modal>
      
      {/* Device Modal */}
      <Row>
        <Modal
          visible={deviceModal}
          footer={false}
          onCancel={() => setDeviceModal(false)}
          max-height={'20%'}
          width={'55%'}
        >
          <DeviceStatus
            assigneddevices={props.patient?.deviceSchedule?.assigneddevices}
            reOrderDeviceSchedule={reOrderDeviceSchedule}
            showDeviceModal={showDeviceModal}
            getPatient ={()=>props.fetchPatient(props.patient._id)}
            isLoading = {props.isLoading}
          />
        </Modal>
        <Modal
          className={'formModal'}
          destroyOnClose={true}
          visible={open}
          footer={false}
          width={'70%'}
          onCancel={() => setOpen(false)}
        >
          {open && <PatientForm close={() => setOpen(false)} type={type} />}
        </Modal>
      </Row>
    </Col>
  )
}

PatientInfo.propTypes = {
  patient: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    notifications: state.patient.notifications,
    role: state.profile.user.role,
    company: state.profile.company,
    user: state.profile.user,
    customer: state.profile.customer,
    isLoading: state.patient.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNotifications: (id) => dispatch(getPatientNots(id)),
    setNotifications: (arr) => dispatch(setPatNotifications(arr)),
    updateDeviceSchedule: (patient, devices, reorder) =>
      dispatch(updateDeviceSchedule({ patient, devices, reorder })),
    getCompanyHealthcoach: (id) =>
      dispatch(getCompanyHealthcoach({ companyid: id })),
    putPatientOnHold: (isNew, id) =>
      dispatch(putPatientOnHold({ isNew, patientid: id })),
    loginAsCompany: (params) => dispatch(loginAsCompany(params)),
    fetchPatient: (id) => dispatch(getPatient(id)),
    resetLoginFailedCount: (id) => dispatch(resetLoginFailedCount(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientInfo)
